{
  "el": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Ενεργοποίηση ακινήτων",
          "allow_customer_issue_creation": "Να επιτρέπεται στους πελάτες να δημιουργούν παρατηρήσεις",
          "block_customer_issue_creation": "Να μην επιτρέπεται στους πελάτες να δημιουργούν παρατηρήσεις",
          "deactivate": "Απενεργοποίηση ακινήτων",
          "give_access": "Παροχή πρόσβασης σε πελάτες",
          "revoke_access": "Ανάκληση πρόσβασης πελατών"
        },
        "go_to_unit": "Μετάβαση στο ακίνητο",
        "revokeAccess": "Ανάκληση πρόσβασης",
        "select": "Επιλογή τύπου",
        "selectOutdoorCategory": "Επιλογή εξωτερικού χώρου",
        "selectUnit": "Επιλογή ακινήτου",
        "setCustomer": "Ανάθεση πελάτη σε",
        "setVisible": "Παροχή πρόσβασης",
        "submit": "Υποβολή",
        "update_pricing": "Ενημέρωση τιμών"
      },
      "attributes": {
        "address_city": "Πόλη",
        "address_country": "Χώρα",
        "address_number": "Αριθμός",
        "address_street": "Οδός",
        "address_zip": "Ταχυδρομικός κώδικας",
        "amount": "Ποσό",
        "bathrooms": "Αριθμός μπάνιων",
        "bedrooms": "Αριθμός υπνοδωματίων",
        "category": "Τύπος",
        "category_outdoor": "Εξωτερικός χώρος",
        "customer": "Πελάτης",
        "deed_signed_at": "Ημερομηνία υπογραφής συμβολαίου",
        "description": "Περιγραφή",
        "electricity": "Ρεύμα",
        "floor": "Όροφος",
        "house_subcategory": "Τύπος κατοικίας",
        "internal_note": "Εσωτερική σημείωση ακινήτου",
        "meter_number": "Αριθμός μετρητή",
        "meter_number_electricity": "Αριθμός μετρητή ρεύματος",
        "meter_number_gas": "Αριθμός μετρητή φυσικού αερίου",
        "meter_number_warmth": "Αριθμός μετρητή θέρμανσης",
        "meter_number_water": "Αριθμός μετρητή νερού",
        "meter_numbers": "Αριθμοί μετρητών",
        "name": "Όνομα",
        "orientation": "Προσανατολισμός",
        "price_value": "Συνολική αξία πώλησης",
        "price_value_construction": "Αξία κατασκευής",
        "price_value_construction_existing": "Κόστος υφιστάμενης κατασκευής",
        "price_value_fees": "Αμοιβές αρχιτέκτονα/μηχανικού",
        "price_value_land": "Αξία οικοπέδου",
        "quotity": "Μερίδιο ποσού μεταβίβασης",
        "sales_employee": "Υπεύθυνος πωλήσεων",
        "surface_garden": "Επιφάνεια κήπου",
        "surface_terrace": "Επιφάνεια βεράντας",
        "surface_total": "Συνολική επιφάνεια",
        "tax_percentage": "Φόρος %",
        "toilets": "Αριθμός τουαλετών",
        "total": "Σύνολο",
        "vat_percentage": "ΦΠΑ %"
      },
      "house_subtype": {
        "detached": "Ανεξάρτητη κατοικία",
        "rowhouse": "Κατοικία σε σειρά",
        "semidetached": "Ημιανεξάρτητη κατοικία"
      },
      "labels": {
        "activate": "Ενεργοποίηση",
        "address": "Διεύθυνση",
        "areYouSureDeactivate": "Θέλεις σίγουρα να απενεργοποιήσεις {unit_name};",
        "bathrooms": "μπάνιο | μπάνια",
        "bedrooms": "υπνοδωμάτιο | υπνοδωμάτια",
        "cannot_activate_all_units": "Δεν έχεις αρκετά διαθέσιμα ακίνητα για να ενεργοποιήσεις όλα τα επιλεγμένα ακίνητα",
        "customer_can_create_issue_project_off": "Απενεργοποιημένο για όλο το έργο στις ρυθμίσεις του έργου.",
        "customer_issue_creation_unit_off": "Δεν μπορείτε πλέον να καταχωρίσετε παρατηρήσεις για αυτή τη μονάδα.",
        "deactivate": "Απενεργοποίηση",
        "deactivateMessage": "Ο πελάτης μπορεί να συνεχίσει να επικοινωνεί μαζί σου και θα έχει πρόσβαση σε όλες τις πληροφορίες του. Ωστόσο, οι υπόλοιπες ενέργειες, όπως η δημιουργία αποφάσεων, το ανέβασμα εγγράφων ή η αποστολή ερωτηματολογίων για {unit_name}, δεν θα είναι δυνατές.",
        "deactivated": "Απενεργοποιημένο",
        "notAvailableDeactivated": "Μη διαθέσιμο για απενεργοποιημένο ακίνητο",
        "deedSignedOn": "Το συμβόλαιο υπογράφηκε στις {date}",
        "deedWillBeSignedOn": "Το συμβόλαιο θα υπογραφεί στις {date}",
        "detailed_price": "Αναλυτική",
        "details": "Λεπτομέρειες",
        "email_address_secondary_delivery_content": "λαμβάνει email ειδοποιήσεων ως πρώην δευτερεύουσα επαφή",
        "email_address_secondary_delivery_tip": "Αυτός ο πελάτης προστέθηκε αρχικά ως δευτερεύουσα επαφή στον άλλο πελάτη, πριν υποστηριχθούν πολλοί πελάτες ανά ακίνητο: θα συνεχίσει να λαμβάνει τα ίδια email ειδοποιήσεων με τον άλλο πελάτη, όμως μόνο ο άλλος πελάτης έχει πρόσβαση και σύνδεση στο ακίνητο.",
        "existingVatValues": "Ορισμένες τιμές ΦΠΑ διαφέρουν από το 0",
        "export": "Εξαγωγή",
        "export_preparing": "Η συλλογή των δεδομένων του ακινήτου μπορεί να διαρκέσει λίγα δευτερόλεπτα.",
        "facing": "Προσανατολισμός {direction}",
        "fromATotal": "Σύνολο έργου: {total}",
        "general": "Γενικά",
        "howDoesCustomerSeeThis": "Πώς βλέπει ο πελάτης το ακίνητό του;",
        "integrationNoCustomerAssigned": "Δεν έχει ανατεθεί πελάτης. Ανάθεσε πελάτες στο {integration_name}.",
        "internal": "Εσωτερικά",
        "internalDisclaimer": "Αυτές οι πληροφορίες είναι ορατές μόνο στην ομάδα σου",
        "invitationAddEmailAddress": "Για να δώσεις πρόσβαση στο ακίνητο σε {customer}, συμπλήρωσε πρώτα το email στη σελίδα επαφής του πελάτη.",
        "invitationAddEmailAddress_SUP": "Για να δώσεις πρόσβαση στο έργο σε {customer}, συμπλήρωσε πρώτα το email στη σελίδα επαφής του πελάτη.",
        "invitationSentTo": "Η πρόσκληση για {customer} θα σταλεί σύντομα στο {email}",
        "maintainerNoCustomerAssigned": "Δεν έχει ανατεθεί πελάτης. Μόνο μέλη της ομάδας με ρόλο «Ιδιοκτήτης» μπορούν να αναθέσουν πελάτη σε ακίνητο.",
        "more": "περισσότερα",
        "onFloor": "Στον όροφο",
        "or_create_new": "Δημιουργία νέου",
        "other_units": "Έχει άλλα ακίνητα",
        "price_view": "Προβολή τιμών",
        "sales_value": "Όλες οι τιμές είναι σε {currency}",
        "scopes": {
          "invisible": "Χωρίς πρόσβαση στο ακίνητο",
          "invisible_SUP": "Χωρίς πρόσβαση στο έργο",
          "visible": "Έχει πρόσβαση",
          "visible_SUP": "Έχει πρόσβαση"
        },
        "scopes_description": {
          "invisible": "Ο πελάτης δεν έχει ακόμη πρόσβαση σε αυτό το ακίνητο στην πύλη πελατών",
          "invisible_SUP": "Ο πελάτης δεν έχει ακόμη πρόσβαση σε αυτό το έργο στην πύλη πελατών",
          "visible": "Ο πελάτης έχει πρόσβαση σε αυτό το ακίνητο στην πύλη πελατών",
          "visible_SUP": "Ο πελάτης έχει πρόσβαση σε αυτό το ακίνητο στην πύλη πελατών"
        },
        "search_unit": "Αναζήτηση ακινήτου ή πελάτη...",
        "selectUnit": "Επίλεξε ένα ακίνητο",
        "select_contact_required": "Επίλεξε πρώτα μια επαφή",
        "select_existing_contact": "Υπάρχουσα",
        "set_unit_price": "Ορισμός τιμής ακινήτου",
        "showUnit": "Εμφάνιση ακινήτου",
        "simple_price": "Απλή",
        "toggleDetailedPrice": "Αλλαγή προβολής τιμών",
        "unassigned": "Δεν έχει ανατεθεί πελάτης",
        "unit": "Κανένα ακίνητο | Ένα ακίνητο | {count} ακίνητα",
        "unitLabel": "Ακίνητο",
        "units": "Ακίνητα",
        "units_assigned_count": "{assigned} / {total} ακίνητα",
        "units_not_added": "{count} ακίνητο δεν έχει προστεθεί ακόμα | {count} ακίνητα δεν έχουν προστεθεί ακόμα",
        "utilities": "Παροχές",
        "visibleCustomer": "Αυτές οι πληροφορίες είναι ορατές στους πελάτες"
      },
      "outdoor_category": {
        "balcony": "Μπαλκόνι",
        "garden": "Κήπος",
        "null": "Κανένα",
        "terrace": "Βεράντα",
        "terrace_garden": "Βεράντα + Κήπος"
      },
      "status": {
        "unavailable": "Μη διαθέσιμο"
      },
      "toasts": {
        "activateSuccess": "Το ακίνητο {unit_name} ενεργοποιήθηκε με επιτυχία",
        "create_fixed": "Το ακίνητο δημιουργήθηκε",
        "create_rundle": "Δημιουργήθηκε νέο ενεργό ακίνητο. Απομένει 1 ενεργό ακίνητο. | Δημιουργήθηκε νέο ενεργό ακίνητο. Απομένουν {count} ενεργά ακίνητα.",
        "deactivateSuccess": "Το ακίνητο {unit_name} απενεργοποιήθηκε με επιτυχία",
        "delete": "Το ακίνητο διαγράφηκε",
        "update": "Το ακίνητο ενημερώθηκε"
      },
      "type": {
        "alf": "Στέγη υποβοηθούμενης διαβίωσης",
        "apartment": "Διαμέρισμα",
        "cellar": "Υπόγειο",
        "commercial": "Εμπορικό ακίνητο",
        "duplex": "Μεζονέτα",
        "house": "Κατοικία",
        "loft": "Loft",
        "office": "Γραφείο",
        "penthouse": "Ρετιρέ",
        "sme": "Ακίνητο ΜμΕ",
        "studio": "Στούντιο"
      },
      "validation": {
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 85)",
        "pricesNotUpdatable": "Ορισμένες ή όλες οι τιμές έχουν χρησιμοποιηθεί σε δόσεις και γι' αυτό δεν μπορούν να τροποποιηθούν. Αφαίρεσε τις σχετικές δόσεις για να μπορέσεις να επεξεργαστείς ξανά τις τιμές",
        "totalSalesValueNotEqualToParts": "Η συνολική αξία πώλησης δεν φαίνεται να ισούται με το άθροισμα των επιμέρους τιμών"
      }
    }
  }
}
